export const blockIconsHouseholdKitchenNew = (
	<span className='material-symbols-outlined'>kitchen</span>
);
